/**
 * Global search constants
 *
 *
 * @author Matthew Rawson @ 17/10/2017 16:31
 * @type {string}
 */
export const MIN_SEARCH_CHARACTERS = 2
export const DEFAULT_SEARCH_LIMIT = 100
export const DEFAULT_GEO_SEARCH_LIMIT = 1000
export const DEFAULT_DEBOUNCE_SEARCH_DELAY = 300
export const DEFAULT_DEBOUNCE_TYPING_TO_URL = 300
export const MAX_RESULTS_PER_SECTION = 4

export const SECTION_REWARDS = "rewards"
export const SECTION_PERKS = "perks"
export const SEARCH_SECTIONS = [SECTION_PERKS, SECTION_REWARDS]

export default {
  MIN_SEARCH_CHARACTERS,
  DEFAULT_SEARCH_LIMIT,
  DEFAULT_DEBOUNCE_SEARCH_DELAY,
  DEFAULT_DEBOUNCE_TYPING_TO_URL,
  MAX_RESULTS_PER_SECTION,
  SECTION_PERKS,
  SEARCH_SECTIONS
}
